/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOutPhoto
 */
export interface PropertyOutPhoto {
    /**
     * 
     * @type {string}
     * @memberof PropertyOutPhoto
     */
    imageFileLocation: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutPhoto
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOutPhoto
     */
    modificationDate: Date;
}

export function PropertyOutPhotoFromJSON(json: any): PropertyOutPhoto {
    return PropertyOutPhotoFromJSONTyped(json, false);
}

export function PropertyOutPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOutPhoto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imageFileLocation': json['imageFileLocation'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutPhotoToJSON(value?: PropertyOutPhoto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imageFileLocation': value.imageFileLocation,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


